import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';
import { ListaAliquotaIbsResponse } from '../../responses/motor-fiscal/lista-aliquota-ibs.response';
import { AliquotaCbsResponse } from '@shared/services/responses/motor-fiscal/aliquota-cbs.response';
import { SalvarAliquotaCbsRequest } from '@shared/services/requests/motor-fiscal/salvar-aliquota-cbs.request';

/** Alíquotas IBS por UF/município e CBS (base global + override por empresa). Salvamento direto (fora do fluxo da regra). */
@Injectable({ providedIn: 'root' })
export class AliquotaIbsService extends CommonService {
    private readonly apiUrl: string = environment.urlApiMotorFiscal + 'AliquotaIbs';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getIbsUf(): Observable<ListaAliquotaIbsResponse> {
        return this.httpClient.get<ListaAliquotaIbsResponse>(`${this.apiUrl}/ibs-uf`, {
            ...this.addHeaderToken()
        }).pipe(catchError(this.handleError));
    }

    public getIbsMunicipioEfetivas(ids: number[]): Observable<ListaAliquotaIbsResponse> {
        return this.httpClient.post<ListaAliquotaIbsResponse>(`${this.apiUrl}/ibs-municipio/efetivas`, { ids }, {
            ...this.addHeaderToken()
        }).pipe(catchError(this.handleError));
    }

    public getCbs(): Observable<AliquotaCbsResponse> {
        return this.httpClient.get<AliquotaCbsResponse>(`${this.apiUrl}/cbs`, {
            ...this.addHeaderToken()
        }).pipe(catchError(this.handleError));
    }

    public salvarIbsUf(idUf: number, pAliquota: number): Observable<ReturnStruct> {
        return this.httpClient.put<ReturnStruct>(`${this.apiUrl}/ibs-uf/${idUf}`, { pAliquota }, {
            ...this.addHeaderToken()
        }).pipe(catchError(this.handleError));
    }

    public salvarCbs(request: SalvarAliquotaCbsRequest): Observable<ReturnStruct> {
        return this.httpClient.put<ReturnStruct>(`${this.apiUrl}/cbs`, request, {
            ...this.addHeaderToken()
        }).pipe(catchError(this.handleError));
    }

    public salvarIbsMunicipio(idMunicipio: number, pAliquota: number): Observable<ReturnStruct> {
        return this.httpClient.put<ReturnStruct>(`${this.apiUrl}/ibs-municipio/${idMunicipio}`, { pAliquota }, {
            ...this.addHeaderToken()
        }).pipe(catchError(this.handleError));
    }
}
